import React, { useContext, useEffect, useState } from "react";
import "../../../assests/css/teachers/TeacherCourses.css";
import TeacherMasterLayout from "../../../layouts/TeacherMasterLayout";
import { AppContext } from "../../../context/Appcontext";
import axios from "axios";

const TeacherCourses = () => {
  const [activeCourse, setActiveCourse] = useState(null);
  const { baseUrl, loggedInTeacher } = useContext(AppContext);

  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleDetailsClick = (id) => {
    setActiveCourse((prev) => (prev === id ? null : id));
  };

   const viewAllTeacherCourse = () => {
    console.log(courses);
    setLoading(true);
    const formData = new FormData();
    formData.append("ngteacher_id", loggedInTeacher?.id)
    axios.post(`${baseUrl}/teacher/course/viewAllTeacherCourse`, formData, {
      headers: {
      
        "Content-Type" : "multipart/form-data"
      }
    })
      .then((response) => {
        console.log(response.data);
        if(response.data.success == true){
          setCourses(response.data.courses)
        }
         setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };


  useEffect(() => {
    viewAllTeacherCourse();
  }, []);
  

  return (
    <TeacherMasterLayout>
      {/* ===== Topbar ===== */}
      <header className="tc-topbar">
        <h3>Welcome, Teacher 👋</h3>
        <div className="tc-profile">👤</div>
      </header>

      <div className="tc-courses">

        {/* ===== Header ===== */}
        <div className="tc-courses-header">
          <div>
            <h2>My Courses</h2>
            <p>Courses assigned to you this semester</p>
          </div>

          <span className="tc-semester-badge">
            Spring 2024
          </span>
        </div>

        {/* ===== Loading ===== */}
        {loading ? (
          <p className="tc-loading">Loading courses...</p>
        ) : (
          <>
            {/* ===== Stats ===== */}
            <div className="tc-course-stats">

              <div className="tc-stat-card">
                <h3>{courses.length}</h3>
                <p>Total Courses</p>
              </div>

              <div className="tc-stat-card">
                <h3>
                  {courses.reduce(
                    (total, item) =>
                      total + (item.students || 0),
                    0
                  )}
                </h3>
                <p>Total Students</p>
              </div>

              <div className="tc-stat-card">
                <h3>Active</h3>
                <p>Status</p>
              </div>

            </div>

            {/* ===== Courses Grid ===== */}
            <div className="tc-courses-grid">

              {courses.length > 0 ? (
                courses.map((course) => (
                  <div
                    className="tc-course-card"
                    key={course.id}
                  >
                    <div className="tc-course-top">

                      <span className="tc-course-code">
                        {course.code || "N/A"}
                      </span>

                      <span className="tc-course-status">
                        {course.status || "Active"}
                      </span>

                    </div>

                    {/* ✅ Fix: ngcourse.name se name le rahe hain */}
                    <h4>
                      {course.ngcourse?.name || course.name || course.title || '—'}
                    </h4>

                    <p className="tc-students">
                      👥 {course.students || 0} Students
                    </p>

                    {/* <div className="tc-course-actions">
                      <button
                        className="tc-btn-outline"
                        onClick={() =>
                          handleDetailsClick(course.id)
                        }
                      >
                        Details
                      </button>
                    </div> */}

                    {/* ===== Course Outline ===== */}
                    {activeCourse === course.id && (
                      <div className="tc-course-outline-full">

                        <h5>
                          {course.ngcourse?.name || course.name || course.title}
                          {" "} - Course Outline
                        </h5>

                        <ul>
                          {course.outline &&
                          course.outline.length > 0 ? (
                            course.outline.map(
                              (topic, idx) => (
                                <li key={idx}>
                                  {topic}
                                </li>
                              )
                            )
                          ) : (
                            <li>
                              No outline available
                            </li>
                          )}
                        </ul>

                        <p className="tc-outline-note">
                          Click Details again to collapse.
                        </p>

                      </div>
                    )}
                  </div>
                ))
              ) : (
                <p>No courses found</p>
              )}

            </div>
          </>
        )}
      </div>
    </TeacherMasterLayout>
  );
};

export default TeacherCourses;